import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.push.js";
import { paperList } from '@/api/mg';
import $ from 'jquery';
export default {
  data: function data() {
    return {
      title: 'Questionnaire',
      questions: []
    };
  },
  created: function created() {
    this.getPaperList({
      page: 1,
      perPage: 10
    });
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      var u = navigator.userAgent; // 判断手机类型
      if (u.indexOf('Android') > -1 || u.indexOf('Linux') > -1) {
        console.log('123451');
        if (window.Android) {
          var devicePixelRatio = window.devicePixelRatio;
          console.log(devicePixelRatio);
          console.log(window.Android.getStatusBarHeight());
          var pxSize = Number(window.Android.getStatusBarHeight() / devicePixelRatio);
          console.log('pxsize', pxSize);
          $('.titleBar').css('padding-top', pxSize);
        }
      }
    });
  },
  methods: {
    getPaperList: function getPaperList(params) {
      var _this = this;
      paperList(params).then(function (res) {
        if (res.Code === 0) {
          _this.questions = res.Data.pageData;
        } else {
          _this.$message.error(res.Message);
        }
      });
    },
    back: function back() {
      var _this2 = this;
      var timer = setTimeout(function () {
        _this2.$router.back();
        clearTimeout(timer);
      }, 100);
    },
    toAnswer: function toAnswer(id) {
      this.$router.push({
        path: '/social/question',
        query: {
          id: id
        }
      });
    }
  }
};